import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { authConfig } from '../../config/constants';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';


@Injectable()
  export class InterceptorService implements HttpInterceptor {
   
    constructor(private oauthService: OAuthService) {}

    intercept(
      req: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      if(authConfig.IS_Security_Headers) {
        // Only add authentication to backend API requests
        const isBackendRequest = req.url.includes(environment.API_BASE_URL);
        
        if (isBackendRequest) {
          const token = this.oauthService.getAccessToken();
          
          if (token) {
            // Add Bearer token while preserving existing headers (e.g., X-Graph-Token)
            let headers = req.headers
              .set('Content-Type', 'application/json; charset=utf-8')
              .set('Accept', 'application/json')
              .set('Authorization', `Bearer ${token}`);
            
            req = req.clone({ headers });
          }
        }
      }
     
      return next.handle(req);
    }
  }
